module.exports = __webpack_public_path__ + "img/guide11.fd83fbc3.jpg";